const ACTIVATION_KEYS: ReadonlyArray<string> = ['Enter', ' '];

export function isActivationKey(event: KeyboardEvent): boolean {
  return ACTIVATION_KEYS.includes(event.key);
}
